import { AlertTriangle } from "lucide-react";

// SUPPORTED MARKET WITH NO CURRENT MATCH card. Distinct from
// UnsupportedLegCard -- rendered when the market IS analyzed by PA but
// we can't produce a match right now (no_match / no_market_for_player
// / needs_player_confirmation / cache_unavailable / provider_error).
function unmatchedCopy(reason, message) {
  if (reason === "no_match")
    return [
      "Could not match to current MLB market data",
      message || "PA could not find this player in today's MLB market data.",
    ];
  if (reason === "no_market_for_player")
    return [
      "No cached market for this player",
      message || "This market isn't quoted in today's cache for this player.",
    ];
  if (reason === "needs_player_confirmation")
    return [
      "Multiple players matched",
      message || "Multiple players matched — please confirm.",
    ];
  if (reason === "cache_unavailable")
    return [
      "Cached market data not ready",
      message || "Current market data isn't cached yet. Please try again shortly.",
    ];
  if (reason === "provider_error")
    return [
      "This leg couldn't be analyzed",
      message || "PA hit an unexpected error while analyzing this leg.",
    ];
  return ["Leg not analyzed", message || "PA could not analyze this leg."];
}

export function UnmatchedLegCard({ leg }) {
  const [title, body] = unmatchedCopy(leg.reason, leg.message);
  const candidates =
    leg.reason === "needs_player_confirmation" && Array.isArray(leg.candidates)
      ? leg.candidates
      : null;
  return (
    <section
      data-testid={`analyzer-leg-unmatched-${leg.index}`}
      className="pa-card p-6 md:p-8 mt-3"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle size={22} style={{ color: "#b45309" }} />
        <div>
          <h5 className="font-display text-base md:text-lg uppercase tracking-wide text-slate-900">
            {title}
          </h5>
          <p className="mt-1 text-slate-600 text-sm">{body}</p>
          {candidates && (
            <ul className="mt-3 text-sm text-slate-700">
              {candidates.map((c) => (
                <li
                  key={c.player_id}
                  data-testid={`analyzer-data-check-candidate-${c.player_id}`}
                  className="py-1"
                >
                  {c.player_name} · {c.team_abbr || c.away_team || "?"}{" "}
                  {c.start_time || c.game_date
                    ? `· ${new Date(c.start_time || c.game_date).toLocaleString()}`
                    : ""}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </section>
  );
}
